module.exports = __webpack_public_path__ + "img/358ca41.png";